export default "__VITE_ASSET__Cn81tG6R__"